/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = DailyLogs

1 = ClientUpdates

2 = Comments


 */
export type UserInteractionsEntityType =
  (typeof UserInteractionsEntityType)[keyof typeof UserInteractionsEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserInteractionsEntityType = {
  DailyLogs: 0,
  ClientUpdates: 1,
  Comments: 2,
} as const;
